<template>
  <el-dialog
    center
    :visible="show"
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="close"
    v-loading="loading"
    top="10vh"
    width="40%"
  >
    <div :class="$style.wrap">
      <el-button @click="$refs['uploadInput'].click()" :class="$style.button"
        >上传文件</el-button
      >
      <div>选择文件,完成上传</div>
      <input
        @change="handleClick($event)"
        type="file"
        ref="uploadInput"
        v-show="false"
      />
    </div>
    <div :class="$style.text">*说明：1. 请上传标准格式的待手机卡信息excel, <span @click="download('/dist/moban.xlsx','moban')" :class="$style.edit">模板文件下载</span></div>
    <div :class="$style.text">2. 请确保手机号、员工工号及其他数据准确性</div>
  </el-dialog>
</template>

<script>
import { uploadFile } from "./api";
export default {
  name: "UploadDIalog",
  props: {
    show: {
      type: Boolean,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  mounted() {},
  methods: {
    close() {
      this.$emit("update:show", false);
    },
    handleClick(e) {
      let file = e.target.files[0];
      this.upload(file);
    },
    upload(file) {
      if (this.loading) return;
      let formData = new window.FormData();
      formData.append('file', file);
      this.loading = true;
      uploadFile(formData)
        .then((res) => {
          let {code, data, msg} = res
          if(code === 200){
            if(data.failList.length>0){
              this.$message.error("部分数据上传未成功");
            }else{
              this.$message.success("上传成功");
            }
          }else{
            this.$message.error(msg);
          }
          this.loading = false;
          this.$emit("uploaded");
          this.$refs["uploadInput"].value = "";
        })
        .catch((error) => {
          this.loading = false;
          this.$message.error("上传失败");
        });
    },
    download(url, name) {
      const x = new XMLHttpRequest();
      x.open("GET", url, true);
      const type =  url.substring(url.length-4,url.length);
      x.responseType = "blob";
      x.onload = function (e) {
        const url = window.URL.createObjectURL(x.response);
        const a = document.createElement("a");
        a.href = url;
        a.download = `${name}.${type}`; //下载后的文件名
        a.click();
      };
      x.send();
    },
  },
};
</script>

<style lang="scss" module>
.wrap {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 40px;
  border: 1px dashed #339999;
}
.text {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
.button {
  margin: 40px;
}
.edit{
  color: teal;
  cursor: pointer;
}
</style>